import React, { useState, useContext, useEffect } from "react";
import { PatientContext, ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import theme from "../../index.scss";
import LoadingSpinner from "../UIComponents/LoadingSpinner";
import { getDaysFromInjury } from "../../api/TBIRequests";
import ComponentWrapper from "./ComponentWrapper";

const DaysFromInjury = () => {
  const { t } = useTranslation();
  const { patient } = useContext(PatientContext);
  const { dark } = useContext(ThemeContext);

  const [daysFromInjury, setDaysFromInjury] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    let isMounted = true;
    const fetchDaysFromInjury = async () => {
      try {
        const response = await getDaysFromInjury(patient.patientId);
        if (isMounted) {
          setDaysFromInjury(response.data);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching days from injury:", error);
        setLoading(false);
      }
    };

    if (patient && patient.patientId) {
      fetchDaysFromInjury();
    }

    return () => {
      isMounted = false;
    };
  }, [patient]);

  return (
    <ComponentWrapper
      style={{
        textAlign: "center",
        width: "90%",
        minHeight: "5rem",
        fontSize: "1.5rem",
        backgroundColor: dark ? theme.darkModePrimary : "#f7bc12",
        color: dark ? theme.darkModeText : "white",
      }}
    >
      {loading ? (
        <LoadingSpinner />
      ) : daysFromInjury !== null ? (
        `${daysFromInjury} ${t("daysfrominjury.days_from")}`
      ) : (
        t("daysfrominjury.no_date")
      )}
    </ComponentWrapper>
  );
};

export default DaysFromInjury;